import { apiRequest } from './index';

export const fetchUserRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/users/' + id, {}, success, failure);
}

export const fetchUsersRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/users', {}, success, failure);
}

export const createUserRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/users',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editUserRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/users/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deleteUserRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/users/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}
